import { HttpClient } from './serviceBase';

class InventoryService {
    Search = async (filters, config) => 
        await HttpClient.Post(`/api/inventory`, filters, config);

    ExportRequest = async (filters) =>
        await HttpClient.PostFile(`/api/inventory/export`, filters);
}

export default new InventoryService();